import React from 'react';
import AsyncComponent from './async';
import {Route} from 'react-router-dom';

export default [
  <Route
    key="/business/campaign/vto"
    path="business/campaign/vto"
    element={<AsyncComponent />}
  />,
  <Route
    key="/business/campaign/vto-v1"
    path="business/campaign/vto-v1"
    element={<AsyncComponent />}
  />,
];
